export default (theme) => ({
    root: {
        display: 'flex',
        flex: 1,
    },
})
